import { ReactElement } from 'react'
import AccountBalanceIcon from '@mui/icons-material/AccountBalance'
import {
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
} from '@mui/material'
import type { ManagedUserDTO } from '@api/fastAPI.schemas'
import UserOrganisations from '../UserOrganisations'

interface Props {
  users: ManagedUserDTO[]
  onManageOrganisations: (user: ManagedUserDTO) => void
}

const UserList = ({ users, onManageOrganisations }: Props): ReactElement => {
  return (
    <TableContainer component={Paper}>
      <Table sx={{ minWidth: 650 }} aria-label="user table" data-cy="user-list">
        <TableHead>
          <TableRow>
            <TableCell>ID</TableCell>
            <TableCell>Name</TableCell>
            <TableCell>E-Mail</TableCell>
            <TableCell>Organisationen</TableCell>
            <TableCell align="right" />
          </TableRow>
        </TableHead>
        <TableBody>
          {users.length === 0 && (
            <TableRow>
              <TableCell colSpan={5} align="center" sx={{ color: 'text.secondary' }}>
                Keine Einträge
              </TableCell>
            </TableRow>
          )}
          {users.map(user => (
            <TableRow key={user.id}>
              <TableCell>{user.id}</TableCell>
              <TableCell>{user.name || '—'}</TableCell>
              <TableCell>{user.email || '—'}</TableCell>
              <TableCell>
                <UserOrganisations organisations={user.organisations || []} />
              </TableCell>
              <TableCell align="right">
                <Tooltip title="Organisationen">
                  <IconButton
                    size="small"
                    onClick={() => onManageOrganisations(user)}
                    data-cy="btn-manage-organisations"
                  >
                    <AccountBalanceIcon fontSize="small" />
                  </IconButton>
                </Tooltip>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  )
}

export default UserList
